export const ACTIVE_STAFF_KEY = "futgestao:activeStaffId";
export const ACTIVE_STAFF_NAME_KEY = "futgestao:activeStaffName";
